var _path, _rect, _circle, _circle2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M41.0491 6.4543C37.1128 5.27669 33.0604 4.52929 28.963 4.22522C22.1421 3.72192 15.2874 4.50221 8.75414 6.52563C7.03043 7.02355 5.84013 8.5967 5.82959 10.3909V14.2962V38.9632C5.82959 40.6038 6.66772 41.812 8.08988 42.2489C8.30106 42.3087 8.51779 42.3463 8.7708 42.3902L8.77083 42.3902L8.77128 42.3903C8.8386 42.402 8.90848 42.4141 8.98151 42.4272V44.2592C8.98151 45.7933 10.2252 47.0369 11.7593 47.0369H14.2418C15.7759 47.0369 17.0196 45.7933 17.0196 44.2592V42.4317H32.9798V44.2592C32.9798 45.7933 34.2234 47.0369 35.7576 47.0369H38.2713C39.8054 47.0369 41.0491 45.7933 41.0491 44.2592V42.4228L41.3879 42.3693C43.0538 42.1628 44.272 40.6967 44.1698 39.0212V10.6806C44.2831 8.70416 42.9713 6.92774 41.0491 6.4543ZM24.2864 26.8638H9.93556C9.93556 26.8638 8.96814 26.5562 8.96814 25.6289V12.0359C8.96814 11.1131 9.11971 10.9214 10.0247 10.6985C14.6874 9.50038 19.477 8.86576 24.2908 8.80821L24.2864 26.8638ZM24.2908 8.80821V8.7993C24.7367 8.7993 26.6046 8.7993 27.0504 8.82605C31.4603 8.9831 35.8401 9.61839 40.1129 10.7208C40.8663 10.9214 41.0045 11.1175 41.0045 11.9111V18.8614V25.8116C41.0045 26.4982 40.202 26.8638 40.202 26.8638H24.2908V8.80821Z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.266,
    height: 2.675,
    x: 17.867,
    y: 34.911,
    fill: "#B2B2B2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.483,
    cy: 36.694,
    r: 2.675,
    fill: "#B2B2B2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.517,
    cy: 36.694,
    r: 2.675,
    fill: "#B2B2B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.6281 14.7154C48.3485 14.4306 46.6287 14.2699 46.2296 14.2695C46.1702 14.265 46.1106 14.265 46.0513 14.2695V21.4427C46.1106 21.4473 46.1702 21.4473 46.2296 21.4427C47.0566 21.4428 49.0666 20.7762 49.0739 19.9492V15.7764C49.0725 15.3775 48.9121 14.9956 48.6281 14.7154Z",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.46957 14.7154C1.7492 14.4306 3.46892 14.2699 3.86806 14.2695C3.92741 14.265 3.98703 14.265 4.04639 14.2695V21.4427C3.98703 21.4473 3.92741 21.4473 3.86806 21.4427C3.04104 21.4428 1.03109 20.7762 1.02375 19.9492V15.7764C1.02514 15.3775 1.1856 14.9956 1.46957 14.7154Z",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.2e0355fcbe7a3b5115165fb96bdf95ce.svg";
export { ForwardRef as ReactComponent };